import React from "react";
import { styled } from "@mui/system";

const Wrapper = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  alignItems: "flex-start",
  flexWrap: "wrap",
  margin: "8px 0",
  width: "100%",
  minWidth: "0",
});

const Title = styled("span")(({ fontSize }) => ({
  fontFamily: "Arial, sans-serif",
  fontWeight: "bold",
  fontSize: fontSize || "16px",
  whiteSpace: "nowrap",
  marginRight: "8px",
  flexShrink: 0,
  color: "#333",
  minWidth: "fit-content",
}));

const Value = styled("span", {
  shouldForwardProp: (prop) =>
    !["valueColor", "valueFontWeight", "fontSize"].includes(prop),
})(({ fontSize, valueColor, valueFontWeight }) => ({
  fontFamily: "Courier New, monospace",
  fontSize: fontSize || "16px",
  color: valueColor || "#555",
  fontWeight: valueFontWeight ?? 400,
  wordWrap: "break-word",
  minWidth: "0",
}));

const Detail = ({
  title,
  value,
  fontSize,
  valueColor,
  valueFontWeight,
}) => (
  <Wrapper>
    <Title fontSize={fontSize}>{title ? `${title}:` : ""}</Title>{" "}
    <Value
      fontSize={fontSize}
      valueColor={valueColor}
      valueFontWeight={valueFontWeight}
    >
      {value}
    </Value>
  </Wrapper>
);

export default Detail;
